import React from "react";
import CSSClasses from "./LanguagePicker.css";
import { connect } from "react-redux";
import * as StoreActions from "../../../ReduxStore/Actions/ActionIndex";

const LanguagePicker = props => {
  let langauges = [
    {
      id: 1,
      name: "Croatian",
      code: "hr"
    },
    {
      id: 2,
      name: "Bosnian",
      code: "bs"
    },
    {
      id: 3,
      name: "Serbian",
      code: "sr"
    },
    {
      id: 4,
      name: "Slovenian",
      code: "sl"
    },
    {
      id: 5,
      name: "English",
      code: "en"
    },
    {
      id: 6,
      name: "German",
      code: "de"
    }
  ];

  //definiraj klase
  let containerClasses = [CSSClasses.container];

  if (props.currentThemeID === 2) {
    //light
    containerClasses.push(CSSClasses.lightTheme);
  }

  return (
    <div className={containerClasses.join(" ")}>
      <div className={CSSClasses.activeDiv}>&nbsp;</div>

      {langauges.map(lang => {
        let classes = [CSSClasses.buttonBox];

        let isActive = false;

        if (lang.code === props.currentLanguage) {
          isActive = true;
          // if (props.currentThemeID === 2) {
          //   //light
          //   classes.push(CSSClasses.activeLight);
          // } else {
          //   classes.push(CSSClasses.active);
          // }
        }

        return (
          <div
            className={classes.join(" ")}
            key={lang.id}
            onClick={() => btnLang_Click(props, lang.code)}
          >
            <div
              className={[
                CSSClasses.indicator,
                isActive ? CSSClasses.active : ""
              ].join(" ")}
            >
              &nbsp;
            </div>

            <img
              src={require("../../../assets/images/round_flags/" +
                lang.code +
                ".png")}
              className={CSSClasses.imgFlag}
              alt=""
            />

            {props.currentThemeID === 2 ? (
              //light
              <span
                className={[
                  CSSClasses.lblName,
                  CSSClasses.lightThemeLabel,
                  isActive ? CSSClasses.active : ""
                ].join(" ")}
              >
                {lang.name}
              </span>
            ) : (
              <span
                className={[
                  CSSClasses.lblName,
                  isActive ? CSSClasses.active : ""
                ].join(" ")}
              >
                {lang.name}
              </span>
            )}
          </div>
        );
      })}
    </div>
  );
};

const btnLang_Click = (props, langCode) => {
  if (langCode !== props.currentLanguage) {
    //pali loading odmah
    props.startLoading(false, true);
    props.changeLanguage(langCode, true);

    //gasi loading lokalno
    props.stopLoading(false);
  }

  props.changeLanguagePickerVisibility(false);
};

const mapStateToProps = state => {
  return {
    currentLanguage: state.rrAppState.currentLanguage,
    currentThemeID: state.rrAppState.currentActiveLiveTheme
  };
};

const mapDispatchToProps = dispatch => {
  return {
    changeLanguage: (languageCode, updateStorage) =>
      dispatch(StoreActions.SetLanguage(languageCode, updateStorage)),
    changeLanguagePickerVisibility: isShown =>
      dispatch(StoreActions.SetLanguagePickerVisibility(isShown)),
    startLoading: (isTransparent, updateLocalStorage) =>
      dispatch(StoreActions.StartLoading(isTransparent, updateLocalStorage)),
    stopLoading: updateLocalStorage =>
      dispatch(StoreActions.StopLoading(updateLocalStorage))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LanguagePicker);



// WEBPACK FOOTER //
// ./src/Components/Navigation/LanguagePicker/LanguagePicker.js